import React, { useId, useState } from 'react';
import {
  BRING_STORY_LEAD,
  COPY_PROMPT,
  PROMPT_CHOOSER_LEGEND,
  OUTSIDE_CHAT_PROMPT_A,
  OUTSIDE_CHAT_PROMPT_B,
  PROMPT_A_HELP,
  PROMPT_A_TITLE,
  PROMPT_AFTER_COPY,
  PROMPT_B_HELP,
  PROMPT_B_TITLE,
  PROMPT_TRUST_NOTICE,
} from '../../utils/writerCopy';
import './OutsideChatPromptChooser.css';

const PROMPTS = {
  A: OUTSIDE_CHAT_PROMPT_A,
  B: OUTSIDE_CHAT_PROMPT_B,
};

/**
 * Writer picks Prompt A or Prompt B before the outside chat writes the file.
 * Default is B. Clipboard text is the locked prompt, not a paraphrase.
 */
export default function OutsideChatPromptChooser() {
  const group = useId();
  const [which, setWhich] = useState('B');
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(PROMPTS[which]);
        setCopied(true);
      }
    } catch (_) { /* clipboard/permission — silent */ }
  };

  return (
    <div className="prompt-chooser">
      <p className="prompt-chooser__lead">{BRING_STORY_LEAD}</p>
      <fieldset className="prompt-chooser__choices">
        <legend className="prompt-chooser__legend">{PROMPT_CHOOSER_LEGEND}</legend>
        <label className={`prompt-chooser__option${which === 'A' ? ' is-selected' : ''}`}>
          <input
            type="radio"
            name={group}
            value="A"
            checked={which === 'A'}
            onChange={() => { setWhich('A'); setCopied(false); }}
          />
          <span>
            <span className="prompt-chooser__title">{PROMPT_A_TITLE}</span>
            <span className="prompt-chooser__help">{PROMPT_A_HELP}</span>
          </span>
        </label>
        <label className={`prompt-chooser__option${which === 'B' ? ' is-selected' : ''}`}>
          <input
            type="radio"
            name={group}
            value="B"
            checked={which === 'B'}
            onChange={() => { setWhich('B'); setCopied(false); }}
          />
          <span>
            <span className="prompt-chooser__title">{PROMPT_B_TITLE}</span>
            <span className="prompt-chooser__help">{PROMPT_B_HELP}</span>
          </span>
        </label>
      </fieldset>
      <p className="prompt-chooser__notice">{PROMPT_TRUST_NOTICE}</p>
      <button type="button" className="prompt-chooser__copy" onClick={copy}>
        {COPY_PROMPT}
      </button>
      {copied && (
        <p className="prompt-chooser__after" aria-live="polite">{PROMPT_AFTER_COPY}</p>
      )}
    </div>
  );
}
